//Sep 24, 2024 | 10:15 AM GMT+ format
export function getFormattedDateTime() {
  const now = new Date();

  const options = {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };

  const datePart = now.toLocaleString("en-US", options);

  // Get GMT offset in hours and minutes
  const offsetMinutes = now.getTimezoneOffset(); // in minutes
  const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60);
  const offsetMins = Math.abs(offsetMinutes) % 60;
  const sign = offsetMinutes <= 0 ? "+" : "-";
  const gmtPart = `GMT${sign}${offsetHours}${
    offsetMins !== 0 ? `:${offsetMins.toString().padStart(2, "0")}` : ""
  }`;

  return `${datePart.replace(",", "")} | ${gmtPart}`;
}

export const capitalizeFirstLetter = (text) => {
  if (!text) return "";
  return text.charAt(0).toUpperCase() + text.slice(1);
};
